/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_Ddt_GeneratedInputs */

const en_inbound_status_ddt_generated = /** @type {(inputs: Inbound_Status_Ddt_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to the warehouse`)
};

/**
* | output |
* | --- |
* | "Sent to the warehouse" |
*
* @param {Inbound_Status_Ddt_GeneratedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_ddt_generated = /** @type {((inputs?: Inbound_Status_Ddt_GeneratedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_Ddt_GeneratedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_ddt_generated(inputs)
});